module.exports = __webpack_public_path__ + "static/media/linkedin-payment-4-es.dfd99200.png";